export const Image = ({ src }: { src: string }) => {
  return <img className="w-full max-w-90 -mb-20" src={src} alt={src} />;
};
